<template>
  <el-dialog
    :visible.sync="setDialogVisiable"
    class="edit-rule-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="closeForm"
    title="查看标记规范"
    top="5vh"
    width="700px"
  >
    <div class="main">
      <div class="type_list">
        <span
          :class="curTab === 'example' ? 'active' : ''"
          @click="curTab = 'example'"
        >标记案例</span>
        <span
          :class="curTab === 'rule' ? 'active' : ''"
          @click="curTab = 'rule'"
        >标记规范</span>
      </div>
      <div class="content">
        <div
          v-show="curTab === 'example'"
          class="example_main"
          v-scrollbar
        >
          <editRuleText></editRuleText>
        </div>
        <div
          class="rule_main"
          v-show="curTab === 'rule'"
        >
          <p>1、所有题号支持1.或1、两种格式。</p>
          <p>2、所有题型 “【解析】” 字段非必需，没有可不填。</p>
          <p>3、若包含相似的【解析】【分析】【解答】【详解】等标签，均被合并识别为【解析】。</p>
          <p>4、所有题型题目中包含图片，则将图片插入到指定位置即可。</p>
          <p>5、选择题最少支持2个选项A,B，最多支持7个选项A,B,C,D,E,F,G且按照顺序使用。</p>
          <p>6、选择题A-G这些选项号与内容之间要用、或 . 分开。</p>
          <p>7、判断题答案支持 “错误”，“正确” 或者 “错”，“对”。</p>
          <p>8、组合题必须有大题和小题的区分标识。</p>
          <p>9、各学科支持的题型：</p>
          <div class="question_type_list" v-if="basicQuestionType.length > 0">
            <em>【{{ basicQuestionType[0].stageName }}{{ basicQuestionType[0].name }}】</em>:
            <template v-for="(item, index) in basicQuestionType">
              <span :key="index"></span>{{ item.name }}
            </template>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div
      class="close-btn"
      @click="closeForm"
    >
      关闭
    </div>
  </el-dialog>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { deepClone, isEmpty, newGuid } from '@/utils/tools';
import editRuleText from "./editRuleText";


export default {
  name: "edit-rule-dialog",
  components: {
    editRuleText
  },
  data() {
    return {
      curTab: "example",
    };
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  watch: {
    async setDialogVisiable(newValue, oldValue) {
      if (newValue) {
        console.log(this.basicQuestionType);
      }
    },
  },
  mounted() {},
  computed: {
    ...mapState({
      // 不要m选n
      basicQuestionType(state) {
        if (!state.basicDataV3.basicQuestionType) {
          return []
        }
        return state.basicDataV3.basicQuestionType.filter(item => {
          return !isEmpty(item.structureTypeId) && item.structureTypeId !== 6
        })
      }
    }),
    setDialogVisiable: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeForm() {
      this.setDialogVisiable = false;
    },
  },
};
</script>
<style lang='scss'>
.edit-rule-dialog {
  .el-dialog {
    border-radius: 4px;
  }

  .el-dialog__header {
    font-weight: bold;
    font-size: 16px;
    color: #1d2129;
    line-height: 24px;
    padding: 16px;
    // border: 1px solid #e5e6eb;
    border-radius: 4px 4px 0 0;

    .title {
      font-size: 16px;
      font-style: normal;
      color: #1d2129;
      line-height: 24px;

      em {
        font-weight: normal;
        font-style: normal;
        font-size: 14px;
        line-height: 24px;
        color: #4e5969;
      }
    }
  }
  .el-dialog__body {
    padding: 0 0 16px 0;
    border-radius: 0 0 4px 4px;

    .main {
      padding: 16px;

      .type_list {
        width: 204px;
        min-height: 32px;
        margin: 0;
        padding: 0;
        background: #ffffff;
        border-radius: 4px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 12px;
        border: 1px solid #E5E6EB;

        span {
          display: block;
          width: 80px;
          height: 32px;
          color: #4e5969;
          border-radius: 4px;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
          padding: 0 10px;
        }

        span.active {
          background: #0fa784;
          color: #fff;
        }
      }

      .content {
        min-height: 300px;

        .example_main {
          height: calc(95vh - 250px);
          position: relative;
          padding: 40px;
          border: 1px solid #E5E6EB;

          img {
            width: 100%;
          }
        }

        .rule_main {
          padding: 40px;
          border: 1px solid #E5E6EB;

          p {
            margin: 0;
            line-height: 22px;
          }

          .question_type_list {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;

            em {
              // color: #0fa784;
              line-height: 22px;
              font-style: normal;
            }

            span {
              line-height: 22px;
              margin-right: 4px;
            }
          }
        }
      }
    }

    hr {
      margin-top: 16px;
      background: #e5e6eb;
      height: 1px;
      border: 0px solid #e5e6eb;
    }

    .close-btn {
      width: 88px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      color: #fff;
      border: 1px solid #C9CDD4;
      border-radius: 2px;
      margin: 16px auto 0 auto;
      cursor: pointer;
      box-sizing: border-box;
      color: #4E5969;
      background: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/components/editRuleDialog.vue